import React from 'react';
import { ArcDrone } from '@src/core/components';
import { useOrderProvider } from '@src/features/order/provider';
import { ArcContent, ArcSkeleton, ArcStack, ArcText } from '@src/core/ui';

import { ReadyForTakeOffOrdersProps } from './types';
import { useNavigate } from 'react-router-dom';
import { routesConfig } from '@src/core/routes';

const ReadyForTakeOffOrders: React.FC<ReadyForTakeOffOrdersProps> = () => {
  const navigate = useNavigate();
  const { orders, isLoading } = useOrderProvider();

  if (isLoading) {
    return (
      <ArcStack spacing={1} my={1}>
        <ArcSkeleton height={75} />
        <ArcSkeleton height={75} />
        <ArcSkeleton height={75} />
      </ArcStack>
    );
  }

  if (orders.ready_for_take_off.length < 1) {
    return (
      <ArcContent
        height={75}
        display="flex"
        alignItems="center"
        justifyContent="center"
        textAlign="center"
      >
        <ArcText.h5>No orders</ArcText.h5>
      </ArcContent>
    );
  }

  return (
    <ArcStack spacing={1}>
      {orders.ready_for_take_off.map((o) => (
        <ArcDrone.primary 
          key={o.missionId} 
          drone={o.drone}
          onClick={() => navigate(`${routesConfig.readyForTakeOffViewer}/${o.missionId}`)} />
      ))}
    </ArcStack>
  );
};

export default ReadyForTakeOffOrders;
